export const trainingListData = [
  {
    Image: "user-32.jpg",
    TrainingType: "Git Training",
    Trainer: "Anthony Lewis",
    Employee: "4",
    Img1: "user-01.jpg",
    Img2: "user-02.jpg",
    Img3: "user-03.jpg",
    Img4: "user-04.jpg",
    Img5: "user-05.jpg",
    TimeDuration: "12 Jan 2024 - 12 Feb 2024",
    Description: "Version control and code collaboration.",
    Cost: "$200",
    Status: "Active",
    key: "1",
  },
  {
    Image: "user-09.jpg",
    TrainingType: "HTML Training",
    Trainer: "Brian Villalobos",
    Employee: "3",
    Img1: "user-30.jpg",
    Img2: "user-28.jpg",
    Img3: "user-03.jpg",
    Img4: "user-07.jpg",
    Img5: "user-09.jpg",
    TimeDuration: "17 Jan 2024 - 17 Feb 2024",
    Description: "Basics of web page structure and markup.",
    Cost: "$100",
    Status: "Active",
    key: "2",
  },
  {
    Image: "user-01.jpg",
    TrainingType: "React Training",
    Trainer: "Harvey Smith",
    Employee: "6",
    Img1: "user-32.jpg",
    Img2: "user-21.jpg",
    Img3: "user-01.jpg",
    Img4: "user-05.jpg",
    Img5: "user-18.jpg",
    TimeDuration: "10 Feb 2024 - 10 Mar 2024",
    Description: "Dynamic web applications with components",
    Cost: "$300",
    Status: "Active",
    key: "3",
  },
  {
    Image: "user-33.jpg",
    TrainingType: "Nodejs Training",
    Trainer: "Stephan Peralt",
    Employee: "5",
    Img1: "user-28.jpg",
    Img2: "user-19.jpg",
    Img3: "user-11.jpg",
    Img4: "user-22.jpg",
    Img5: "user-17.jpg",
    TimeDuration: "20 Feb 2024 - 20 Mar 2024",
    Description: "Building scalable server-side applications",
    Cost: "$250",
    Status: "Active",
    key: "4",
  },
  {
    Image: "user-34.jpg",
    TrainingType: "Vuejs Training",
    Trainer: "Doglas Martini",
    Employee: "7",
    Img1: "user-23.jpg",
    Img2: "user-13.jpg",
    Img3: "user-12.jpg",
    Img4: "user-25.jpg",
    Img5: "user-19.jpg",
    TimeDuration: "16 Mar 2024 - 16 Apr 2024",
    Description: "Interactive single-page applications",
    Cost: "$280",
    Status: "Active",
    key: "5",
  },
];
